export default "__VITE_PUBLIC_ASSET__86029516__"